
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-story",
      function () {
        return require("private-next-pages/our-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-story"])
      });
    }
  